import { userStore } from 'stores/user';
import { $api } from '.';
import { IUser } from 'types/user';

export class UserService {
  async getUser() {
    const { setUserData, setUserDataLoading } = userStore.getState();

    try {
      setUserDataLoading(true);
      const url = '/api/users';
      const { data } = await $api.get<IUser>(url);
      setUserData(data);

      return data;
    } catch (error) {
      console.error(error);
    } finally {
      setUserDataLoading(false);
    }
  }

  async registerUser() {
    const url = '/api/auth/register';
    const { data } = await $api.post<IUser>(url);
    this.getUser();
    return data;
  }
}

export const userService = new UserService();
